export enum AccInvoiceBillingMethod {
  Time = 'time',
  Distance = 'distance',
  Units = 'units',
  FlatFee = 'flat fee',
}

export enum AccInvoiceStatus {
  Submitted = 'Submitted',
}

export enum AccInvoiceProcessingStatus {
  Authorised = 'Authorised',
  AwaitingAuthorisation = 'Awaiting Authorisation',
  Cancelled = 'Cancelled',
  CompleteAwaitingValidation = 'Complete & Awaiting Validation',
  Incomplete = 'Incomplete',
  Invalid = 'Invalid',
  Paid = 'Paid',
  PartiallyPaid = 'Partially Paid',
  SentToAR = 'Sent-to-AR',
}

export enum AccInvoicePaymentStatus {
  AwaitingAuthorisation = 'Awaiting Authorisation',
  Authorised = 'Authorised',
  Paid = 'Paid',
  Cancelled = 'Payment Cancelled',
  RemitAdvised = 'Remit Advised',
  SelectedForPay = 'Selected for Pay/Advice',
  SentToAR = 'Sent-to-AR',
}
